import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Authority } from 'src/app/models/principal/authority';
import { PortalStateService } from '../../../services/portal-state.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  fullName = '';
  email = '';
  initials = '';
  roleKey: string | null = null;

  constructor(private authService: AuthService, private portalStateService: PortalStateService) {}

  ngOnInit(): void {
    const attributes = this.authService.principal?.attributes;
    const givenName = attributes?.given_name || '';
    const familyName = attributes?.family_name || '';
    this.fullName = `${givenName} ${familyName}`.trim();
    this.email = attributes?.email || '';
    this.initials = (givenName.charAt(0) + familyName.charAt(0)).toUpperCase();
    this.roleKey = this.resolveRoleKey();
  }

  goHome(): void {
    this.portalStateService.goHome();
  }

  openFaq(): void {
    this.portalStateService.viewFaq();
  }

  logout(): void {
    this.authService.logout();
  }

  /** Translation key of the role shown in the user dropdown; Release Manager takes precedence over Reader. */
  private resolveRoleKey(): string | null {
    if (!this.authService.principal?.authorities) {
      return null;
    }
    if (this.authService.hasAuthority(Authority.RELEASE_MANAGER)) {
      return 'FEATURES.HEADER.ROLE_RELEASE_MANAGER';
    }
    if (this.authService.hasAuthority(Authority.READER)) {
      return 'FEATURES.HEADER.ROLE_READER';
    }
    return null;
  }
}
